// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from 'D:/a/1/s/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAppAuth0 from 'D:/a/1/s/src/models/appAuth.js';
import ModelChat1 from 'D:/a/1/s/src/models/chat.js';
import ModelGlobal2 from 'D:/a/1/s/src/models/global.js';
import ModelLogin3 from 'D:/a/1/s/src/models/login.js';
import ModelMaps4 from 'D:/a/1/s/src/models/maps.js';
import ModelNotifications5 from 'D:/a/1/s/src/models/notifications.js';
import ModelSessionNavigation6 from 'D:/a/1/s/src/models/sessionNavigation.js';
import ModelSetting7 from 'D:/a/1/s/src/models/setting.js';
import ModelUser8 from 'D:/a/1/s/src/models/user.js';
import ModelModel9 from 'D:/a/1/s/src/pages/administration-agents/agent-builder/model.js';
import ModelModel10 from 'D:/a/1/s/src/pages/administration-agents/ai-agent-work/model.js';
import ModelModel11 from 'D:/a/1/s/src/pages/administration-agents/ai-skills/model.js';
import ModelModel12 from 'D:/a/1/s/src/pages/administration-agents/ai-vectors/model.js';
import ModelModel13 from 'D:/a/1/s/src/pages/administration-agents/model.js';
import ModelModel14 from 'D:/a/1/s/src/pages/administration-agents/rpa-agents/model.js';
import ModelModel15 from 'D:/a/1/s/src/pages/administration-reports/model.js';
import ModelModel16 from 'D:/a/1/s/src/pages/Administration/model.js';
import ModelModel17 from 'D:/a/1/s/src/pages/applications/application-detail/model.js';
import ModelModel18 from 'D:/a/1/s/src/pages/applications/model.js';
import ModelModel19 from 'D:/a/1/s/src/pages/approvers/manage-approver-entity-position/model.js';
import ModelModel20 from 'D:/a/1/s/src/pages/approvers/manage-approver-entity-user-group/model.js';
import ModelModel21 from 'D:/a/1/s/src/pages/approvers/manage-approver-entity-user/model.js';
import ModelModel22 from 'D:/a/1/s/src/pages/approvers/manage-approver-global-entity-area/model.js';
import ModelModel23 from 'D:/a/1/s/src/pages/approvers/manage-approver-user-group/model.js';
import ModelModel24 from 'D:/a/1/s/src/pages/approvers/manage-user-global-group-approver-area/model.js';
import ModelModel25 from 'D:/a/1/s/src/pages/approvers/manage-user-group-approver-position/model.js';
import ModelModel26 from 'D:/a/1/s/src/pages/approvers/model.js';
import ModelModel27 from 'D:/a/1/s/src/pages/apps/model.js';
import ModelModel28 from 'D:/a/1/s/src/pages/apps/sites/model.js';
import ModelModel29 from 'D:/a/1/s/src/pages/billing/checkout/model.js';
import ModelModel30 from 'D:/a/1/s/src/pages/certificates/model.js';
import ModelModel31 from 'D:/a/1/s/src/pages/CompanyPortal/model.js';
import ModelModel32 from 'D:/a/1/s/src/pages/configurations/access-log/model.js';
import ModelModel33 from 'D:/a/1/s/src/pages/configurations/access-policies/model.js';
import ModelModel34 from 'D:/a/1/s/src/pages/configurations/ai-agent-teams/model.js';
import ModelModel35 from 'D:/a/1/s/src/pages/configurations/ai-billing/credits/model.js';
import ModelModel36 from 'D:/a/1/s/src/pages/configurations/ai-billing/model.js';
import ModelModel37 from 'D:/a/1/s/src/pages/configurations/ai-billing/periods/model.js';
import ModelModel38 from 'D:/a/1/s/src/pages/configurations/ai-consumptions/model.js';
import ModelModel39 from 'D:/a/1/s/src/pages/configurations/ai-skill-groups/model.js';
import ModelModel40 from 'D:/a/1/s/src/pages/configurations/areas/model.js';
import ModelModel41 from 'D:/a/1/s/src/pages/configurations/billing-subscription-payments/model.js';
import ModelModel42 from 'D:/a/1/s/src/pages/configurations/billing-subscriptions/model.js';
import ModelModel43 from 'D:/a/1/s/src/pages/configurations/channel-agreements/model.js';
import ModelModel44 from 'D:/a/1/s/src/pages/configurations/channel-customer-assignments/model.js';
import ModelModel45 from 'D:/a/1/s/src/pages/configurations/channel-distributors/model.js';
import ModelModel46 from 'D:/a/1/s/src/pages/configurations/channel-onboarding/model.js';
import ModelModel47 from 'D:/a/1/s/src/pages/configurations/channel-operators/model.js';
import ModelModel48 from 'D:/a/1/s/src/pages/configurations/channel-partners/model.js';
import ModelModel49 from 'D:/a/1/s/src/pages/configurations/channel-plans/model.js';
import ModelModel50 from 'D:/a/1/s/src/pages/configurations/channel-referral-agents/model.js';
import ModelModel51 from 'D:/a/1/s/src/pages/configurations/channel-registration-approvals/model.js';
import ModelModel52 from 'D:/a/1/s/src/pages/configurations/channel-resellers/model.js';
import ModelModel53 from 'D:/a/1/s/src/pages/configurations/connection-group/model.js';
import ModelModel54 from 'D:/a/1/s/src/pages/configurations/custom-list-groups/model.js';
import ModelModel55 from 'D:/a/1/s/src/pages/configurations/customer-discounts/model.js';
import ModelModel56 from 'D:/a/1/s/src/pages/configurations/delegations/configurations/model.js';
import ModelModel57 from 'D:/a/1/s/src/pages/configurations/delegations/delegated-task/model.js';
import ModelModel58 from 'D:/a/1/s/src/pages/configurations/delegations/model.js';
import ModelModel59 from 'D:/a/1/s/src/pages/configurations/dynamic-entity-groups/model.js';
import ModelModel60 from 'D:/a/1/s/src/pages/configurations/email-formats/model.js';
import ModelModel61 from 'D:/a/1/s/src/pages/configurations/EmailMessageTraces/model.js';
import ModelModel62 from 'D:/a/1/s/src/pages/configurations/environments/model.js';
import ModelModel63 from 'D:/a/1/s/src/pages/configurations/extra-user-fields/model.js';
import ModelModel64 from 'D:/a/1/s/src/pages/configurations/financial-administration/model.js';
import ModelModel65 from 'D:/a/1/s/src/pages/configurations/media-categories/model.js';
import ModelModel66 from 'D:/a/1/s/src/pages/configurations/media/model.js';
import ModelModel67 from 'D:/a/1/s/src/pages/configurations/positions/model.js';
import ModelModel68 from 'D:/a/1/s/src/pages/configurations/power-bi-server/model.js';
import ModelModel69 from 'D:/a/1/s/src/pages/configurations/process-group/model.js';
import ModelModel70 from 'D:/a/1/s/src/pages/configurations/process-portal/components/ProcessPortalConfiguration/model.js';
import ModelModel71 from 'D:/a/1/s/src/pages/configurations/process-portal/model.js';
import ModelModel72 from 'D:/a/1/s/src/pages/configurations/report-groups/model.js';
import ModelModel73 from 'D:/a/1/s/src/pages/configurations/report-tokens/model.js';
import ModelModel74 from 'D:/a/1/s/src/pages/configurations/reports/model.js';
import ModelModel75 from 'D:/a/1/s/src/pages/configurations/security-events/destinations/model.js';
import ModelModel76 from 'D:/a/1/s/src/pages/configurations/security-events/model.js';
import ModelModel77 from 'D:/a/1/s/src/pages/configurations/sequences/model.js';
import ModelModel78 from 'D:/a/1/s/src/pages/configurations/sequences/sequenceTraces/model.js';
import ModelModel79 from 'D:/a/1/s/src/pages/configurations/sequences/subSequences/model.js';
import ModelModel80 from 'D:/a/1/s/src/pages/configurations/shortened-urls/model.js';
import ModelModel81 from 'D:/a/1/s/src/pages/configurations/sms-message-traces/model.js';
import ModelModel82 from 'D:/a/1/s/src/pages/configurations/teams-message-traces/model.js';
import ModelModel83 from 'D:/a/1/s/src/pages/configurations/traces/model.js';
import ModelModel84 from 'D:/a/1/s/src/pages/configurations/user-devices/model.js';
import ModelModel85 from 'D:/a/1/s/src/pages/configurations/user-groups/model.js';
import ModelModel86 from 'D:/a/1/s/src/pages/configurations/users/model.js';
import ModelModel87 from 'D:/a/1/s/src/pages/configurations/white-label/model.js';
import ModelModel88 from 'D:/a/1/s/src/pages/connections/connection-group/model.js';
import ModelModel89 from 'D:/a/1/s/src/pages/connections/connections/model.js';
import ModelModel90 from 'D:/a/1/s/src/pages/documents/model.js';
import ModelModel91 from 'D:/a/1/s/src/pages/Entities/Configuration/entity-builder/model.js';
import ModelModel92 from 'D:/a/1/s/src/pages/Entities/Configuration/Setup/model.js';
import ModelModel93 from 'D:/a/1/s/src/pages/Entities/ManageEntities/model.js';
import ModelModel94 from 'D:/a/1/s/src/pages/Entities/model.js';
import ModelModel95 from 'D:/a/1/s/src/pages/External/model.js';
import ModelModel96 from 'D:/a/1/s/src/pages/Launchpad/model.js';
import ModelModel97 from 'D:/a/1/s/src/pages/lists/byList-classic/model.js';
import ModelModel98 from 'D:/a/1/s/src/pages/lists/list-builder/model.js';
import ModelModel99 from 'D:/a/1/s/src/pages/lists/model.js';
import ModelModel100 from 'D:/a/1/s/src/pages/Overview/model.js';
import ModelModel101 from 'D:/a/1/s/src/pages/Process/ManageProcess/instanceNumbering/model.js';
import ModelModel102 from 'D:/a/1/s/src/pages/Process/ManageProcess/model.js';
import ModelModel103 from 'D:/a/1/s/src/pages/Process/model.js';
import ModelModel104 from 'D:/a/1/s/src/pages/Process/process-config/actions/config/custom-notifications/model.js';
import ModelModel105 from 'D:/a/1/s/src/pages/Process/process-config/actions/config/digital-signature-field-mapping/model.js';
import ModelModel106 from 'D:/a/1/s/src/pages/Process/process-config/actions/config/email-template/model.js';
import ModelModel107 from 'D:/a/1/s/src/pages/Process/process-config/actions/config/filter-by-external-users/model.js';
import ModelModel108 from 'D:/a/1/s/src/pages/Process/process-config/actions/model.js';
import ModelModel109 from 'D:/a/1/s/src/pages/Process/process-config/configure-users/model.js';
import ModelModel110 from 'D:/a/1/s/src/pages/Process/process-config/custom-list/model.js';
import ModelModel111 from 'D:/a/1/s/src/pages/Process/process-config/custom-list/setup/components/commands/model.js';
import ModelModel112 from 'D:/a/1/s/src/pages/Process/process-config/custom-list/setup/components/fields/model.js';
import ModelModel113 from 'D:/a/1/s/src/pages/Process/process-config/custom-list/setup/components/pre-filters/model.js';
import ModelModel114 from 'D:/a/1/s/src/pages/Process/process-config/custom-list/setup/model.js';
import ModelModel115 from 'D:/a/1/s/src/pages/Process/process-config/emails/model.js';
import ModelModel116 from 'D:/a/1/s/src/pages/Process/process-config/form/model.js';
import ModelModel117 from 'D:/a/1/s/src/pages/Process/process-config/manage-notification/model.js';
import ModelModel118 from 'D:/a/1/s/src/pages/Process/process-config/model.js';
import ModelModel119 from 'D:/a/1/s/src/pages/Process/process-config/pdf-template/model.js';
import ModelModel120 from 'D:/a/1/s/src/pages/Process/process-config/variables/model.js';
import ModelModel121 from 'D:/a/1/s/src/pages/projects/project-builder/model.js';
import ModelModel122 from 'D:/a/1/s/src/pages/reports/model.js';
import ModelModel123 from 'D:/a/1/s/src/pages/reports/report-builder/model.js';
import ModelModel124 from 'D:/a/1/s/src/pages/tasks/model.js';
import ModelModel125 from 'D:/a/1/s/src/pages/user/business/model.js';
import ModelModel126 from 'D:/a/1/s/src/pages/user/profile/model.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'appAuth', ...ModelAppAuth0 });
app.model({ namespace: 'chat', ...ModelChat1 });
app.model({ namespace: 'global', ...ModelGlobal2 });
app.model({ namespace: 'login', ...ModelLogin3 });
app.model({ namespace: 'maps', ...ModelMaps4 });
app.model({ namespace: 'notifications', ...ModelNotifications5 });
app.model({ namespace: 'sessionNavigation', ...ModelSessionNavigation6 });
app.model({ namespace: 'setting', ...ModelSetting7 });
app.model({ namespace: 'user', ...ModelUser8 });
app.model({ namespace: 'model', ...ModelModel9 });
app.model({ namespace: 'model', ...ModelModel10 });
app.model({ namespace: 'model', ...ModelModel11 });
app.model({ namespace: 'model', ...ModelModel12 });
app.model({ namespace: 'model', ...ModelModel13 });
app.model({ namespace: 'model', ...ModelModel14 });
app.model({ namespace: 'model', ...ModelModel15 });
app.model({ namespace: 'model', ...ModelModel16 });
app.model({ namespace: 'model', ...ModelModel17 });
app.model({ namespace: 'model', ...ModelModel18 });
app.model({ namespace: 'model', ...ModelModel19 });
app.model({ namespace: 'model', ...ModelModel20 });
app.model({ namespace: 'model', ...ModelModel21 });
app.model({ namespace: 'model', ...ModelModel22 });
app.model({ namespace: 'model', ...ModelModel23 });
app.model({ namespace: 'model', ...ModelModel24 });
app.model({ namespace: 'model', ...ModelModel25 });
app.model({ namespace: 'model', ...ModelModel26 });
app.model({ namespace: 'model', ...ModelModel27 });
app.model({ namespace: 'model', ...ModelModel28 });
app.model({ namespace: 'model', ...ModelModel29 });
app.model({ namespace: 'model', ...ModelModel30 });
app.model({ namespace: 'model', ...ModelModel31 });
app.model({ namespace: 'model', ...ModelModel32 });
app.model({ namespace: 'model', ...ModelModel33 });
app.model({ namespace: 'model', ...ModelModel34 });
app.model({ namespace: 'model', ...ModelModel35 });
app.model({ namespace: 'model', ...ModelModel36 });
app.model({ namespace: 'model', ...ModelModel37 });
app.model({ namespace: 'model', ...ModelModel38 });
app.model({ namespace: 'model', ...ModelModel39 });
app.model({ namespace: 'model', ...ModelModel40 });
app.model({ namespace: 'model', ...ModelModel41 });
app.model({ namespace: 'model', ...ModelModel42 });
app.model({ namespace: 'model', ...ModelModel43 });
app.model({ namespace: 'model', ...ModelModel44 });
app.model({ namespace: 'model', ...ModelModel45 });
app.model({ namespace: 'model', ...ModelModel46 });
app.model({ namespace: 'model', ...ModelModel47 });
app.model({ namespace: 'model', ...ModelModel48 });
app.model({ namespace: 'model', ...ModelModel49 });
app.model({ namespace: 'model', ...ModelModel50 });
app.model({ namespace: 'model', ...ModelModel51 });
app.model({ namespace: 'model', ...ModelModel52 });
app.model({ namespace: 'model', ...ModelModel53 });
app.model({ namespace: 'model', ...ModelModel54 });
app.model({ namespace: 'model', ...ModelModel55 });
app.model({ namespace: 'model', ...ModelModel56 });
app.model({ namespace: 'model', ...ModelModel57 });
app.model({ namespace: 'model', ...ModelModel58 });
app.model({ namespace: 'model', ...ModelModel59 });
app.model({ namespace: 'model', ...ModelModel60 });
app.model({ namespace: 'model', ...ModelModel61 });
app.model({ namespace: 'model', ...ModelModel62 });
app.model({ namespace: 'model', ...ModelModel63 });
app.model({ namespace: 'model', ...ModelModel64 });
app.model({ namespace: 'model', ...ModelModel65 });
app.model({ namespace: 'model', ...ModelModel66 });
app.model({ namespace: 'model', ...ModelModel67 });
app.model({ namespace: 'model', ...ModelModel68 });
app.model({ namespace: 'model', ...ModelModel69 });
app.model({ namespace: 'model', ...ModelModel70 });
app.model({ namespace: 'model', ...ModelModel71 });
app.model({ namespace: 'model', ...ModelModel72 });
app.model({ namespace: 'model', ...ModelModel73 });
app.model({ namespace: 'model', ...ModelModel74 });
app.model({ namespace: 'model', ...ModelModel75 });
app.model({ namespace: 'model', ...ModelModel76 });
app.model({ namespace: 'model', ...ModelModel77 });
app.model({ namespace: 'model', ...ModelModel78 });
app.model({ namespace: 'model', ...ModelModel79 });
app.model({ namespace: 'model', ...ModelModel80 });
app.model({ namespace: 'model', ...ModelModel81 });
app.model({ namespace: 'model', ...ModelModel82 });
app.model({ namespace: 'model', ...ModelModel83 });
app.model({ namespace: 'model', ...ModelModel84 });
app.model({ namespace: 'model', ...ModelModel85 });
app.model({ namespace: 'model', ...ModelModel86 });
app.model({ namespace: 'model', ...ModelModel87 });
app.model({ namespace: 'model', ...ModelModel88 });
app.model({ namespace: 'model', ...ModelModel89 });
app.model({ namespace: 'model', ...ModelModel90 });
app.model({ namespace: 'model', ...ModelModel91 });
app.model({ namespace: 'model', ...ModelModel92 });
app.model({ namespace: 'model', ...ModelModel93 });
app.model({ namespace: 'model', ...ModelModel94 });
app.model({ namespace: 'model', ...ModelModel95 });
app.model({ namespace: 'model', ...ModelModel96 });
app.model({ namespace: 'model', ...ModelModel97 });
app.model({ namespace: 'model', ...ModelModel98 });
app.model({ namespace: 'model', ...ModelModel99 });
app.model({ namespace: 'model', ...ModelModel100 });
app.model({ namespace: 'model', ...ModelModel101 });
app.model({ namespace: 'model', ...ModelModel102 });
app.model({ namespace: 'model', ...ModelModel103 });
app.model({ namespace: 'model', ...ModelModel104 });
app.model({ namespace: 'model', ...ModelModel105 });
app.model({ namespace: 'model', ...ModelModel106 });
app.model({ namespace: 'model', ...ModelModel107 });
app.model({ namespace: 'model', ...ModelModel108 });
app.model({ namespace: 'model', ...ModelModel109 });
app.model({ namespace: 'model', ...ModelModel110 });
app.model({ namespace: 'model', ...ModelModel111 });
app.model({ namespace: 'model', ...ModelModel112 });
app.model({ namespace: 'model', ...ModelModel113 });
app.model({ namespace: 'model', ...ModelModel114 });
app.model({ namespace: 'model', ...ModelModel115 });
app.model({ namespace: 'model', ...ModelModel116 });
app.model({ namespace: 'model', ...ModelModel117 });
app.model({ namespace: 'model', ...ModelModel118 });
app.model({ namespace: 'model', ...ModelModel119 });
app.model({ namespace: 'model', ...ModelModel120 });
app.model({ namespace: 'model', ...ModelModel121 });
app.model({ namespace: 'model', ...ModelModel122 });
app.model({ namespace: 'model', ...ModelModel123 });
app.model({ namespace: 'model', ...ModelModel124 });
app.model({ namespace: 'model', ...ModelModel125 });
app.model({ namespace: 'model', ...ModelModel126 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
